import React, { Component } from 'react';
import { Text, View, Pressable, StyleSheet, FlatList, Image } from 'react-native';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';
import OPComponent from './op_component';
import Check from './form/check';

export default class SelectionList extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedId: props.selectedId,
    };
  }

  selectItem(itemId, item) {
    this.setState(
      {
        selectedId: itemId,
      },
      () => {
        this.props.onSelect && this.props.onSelect(itemId, item);
      }
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedId !== prevProps.selectedId) {
      if (this.props.selectedId !== this.state.selectedId) {
        this.setState({
          selectedId: this.props.selectedId,
        });
      }
    }
  }

  renderCircleCheck = (selected) => {
    return (
      <View style={styles.circleCheckContainer}>
        <Check checked={selected} />
      </View>
    );
  };

  renderItem = ({ item }) => {
    // TODO: add radio button style
    const itemSelected = this.state.selectedId == item.id;
    return (
      <Pressable
        style={[
          styles.row,
          itemSelected ? styles.rowSelected : {},
          this.props.checkButtonStyle ? styles.rowCheckButtonStyle : {},
        ]}
        onPress={() => this.selectItem(item.id, item)}
      >
        {!!this.props.checkButtonStyle && this.renderCircleCheck(itemSelected)}
        {this.props.renderImageView && this.props.renderImageView(item)}
        {!!this.props.truncateLabels ? (
          <Text
            style={[styles.labelText, item.extraLabelStyle]}
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {item.label}
          </Text>
        ) : (
          <Text style={[styles.labelText, item.extraLabelStyle]}>{item.label}</Text>
        )}
        {this.props.renderRightView && this.props.renderRightView(item)}
        {itemSelected && !this.props.checkButtonStyle && (
          <Image
            style={{ width: 30, height: 24, tintColor: COLOR.greenColor }}
            source={require('../../../resources/check.png')}
          />
        )}
      </Pressable>
    );
  };

  renderItemNoScroll = (item) => {
    return <View key={`${item.id}`}>{this.renderItem({ item })}</View>;
  };

  render() {
    let containerStyles = this.props.containerStyles
      ? [styles.container, this.props.containerStyles]
      : styles.container;
    const scrolling = this.props.scrolling !== false;
    if (scrolling) {
      return (
        <View style={containerStyles}>
          <FlatList
            data={this.props.items}
            extraData={this.state}
            renderItem={this.renderItem}
            keyExtractor={(item) => `${item.id}`}
          />
        </View>
      );
    } else {
      return <View style={containerStyles}>{this.props.items.map(this.renderItemNoScroll)}</View>;
    }
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: COLOR.altContrast,
    paddingTop: 40,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLOR.contrast,
    paddingHorizontal: 25,
    height: 70,
    borderBottomWidth: 1,
    borderBottomColor: COLOR.accent,
  },
  rowSelected: {
    borderBottomWidth: 2,
    borderBottomColor: COLOR.success,
  },
  labelText: {
    flex: 1,
    ...FONT.regular,
    fontSize: FONT_SIZE.large,
    color: COLOR.textLight,
    marginLeft: 20,
  },
  checkIcon: THEME.checkIcon,
  circleCheckContainer: {
    marginRight: 10,
  },
  rowCheckButtonStyle: {
    borderBottomWidth: 0,
    marginBottom: 2,
  },
});
